export const paths = {
    dealership: "/dealership/:uri",
    vehicle: "/vehicle",
    crawler: "/crawler",
    logs: "/vehicle/logs",
    map: "/map",
    login: "/login",
    entity_manager: "/entity-manager",
    operations: "/operations",
    users: "/users",
    application: "/application",
    not_found: "/404"
};

export const buildDealershipLink = (uri: string) => {
    return paths.dealership.replace(":uri", uri);
};

export const buildVehicleLink = (vin: string) => {
    return paths.vehicle.replace(":vin", vin)
};